import { BookingSources, RefundTypes, RefundReasons } from 'interfaces/PaymentForm';
var BookingCancelationService = /** @class */ (function () {
    function BookingCancelationService() {
    }
    BookingCancelationService.mapToRequest = function (form, bookingRef, language) {
        return {
            language: language,
            bookingRef: bookingRef,
            title: form.title,
            firstName: form.contactFirstName,
            lastName: form.contactLastName,
            email: form.email,
            message: form.message,
            passengers: BookingCancelationService.mapPassengersDataToRequest(form.passengers),
            gvoInsteadOfRefund: form.refundType === RefundTypes.GIFT_CARD,
            airbalticBooking: form.bookingSource === BookingSources.AIR_BALTIC,
            flightIrregularity: form.refundReason === RefundReasons.IRREGULARITY
        };
    };
    BookingCancelationService.mapPassengersDataToRequest = function (passengers) {
        return passengers.map(function (passenger) { return ({
            title: passenger.title,
            firstName: passenger.firstName,
            lastName: passenger.lastName,
            flights: passenger.flights.map(function (_a) {
                var flightDate = _a.flightDate, flightNumber = _a.flightNumber, originLabel = _a.originLabel, destinLabel = _a.destinLabel;
                return ({
                    flightDate: BookingCancelationService.formatDate(flightDate),
                    flightNumber: flightNumber,
                    originLabel: originLabel,
                    destinLabel: destinLabel
                });
            })
        }); });
    };
    BookingCancelationService.formatDate = function (date) {
        var _a = date.split(' / '), day = _a[0], month = _a[1], year = _a[2];
        return "".concat(year, "-").concat(month, "-").concat(day);
    };
    return BookingCancelationService;
}());
export default BookingCancelationService;
